import { useState } from "react";
import linkIcon from "../../../assets/image/icons/svg/icons/Link.svg";
import linkIconAccent from "../../../assets/image/icons/svg/icons/linkIconAccent.svg";

import "./style.scss";
import { linkedInProfileOpener } from "../../../api/linkedInProfileOpener";
import { useAppSelector } from "shared/hooks";
import { appSelectors } from "../../../redux/reducers/app";

const LinkedInBlock = () => {
  const [loadedPicture, setLoadedPicture] = useState(false);
  const appProfile = useAppSelector(appSelectors.appProfile);
  const linkedInfo = useAppSelector(appSelectors.linkedProfile);

  const personFullName = useAppSelector(appSelectors.fullName);

  const openLinkedinProfile = () => linkedInProfileOpener.open(linkedInfo);

  const openLinkedinProfilePersona = () =>
    linkedInProfileOpener.open(appProfile.impersonatedPersona.linkedInProfile);

  return (
    <div className="linkedin">
      <div className="linkedin__title">
        LinkedIn profile
        {appProfile?.impersonatedPersona ? (
          <div className="linkedin__account-accent">
            <div className="linkedin__image">
              {appProfile.impersonatedPersona.linkedInProfile.pictureUrl && (
                <img
                  src={
                    appProfile.impersonatedPersona.linkedInProfile.pictureUrl
                  }
                  alt="avatar"
                  className={!loadedPicture ? "hidden-block" : ""}
                  onLoad={() => setLoadedPicture(true)}
                />
              )}
              {!appProfile.impersonatedPersona.linkedInProfile.pictureUrl && (
                <div className="fake-img qwe" />
              )}
              {appProfile.impersonatedPersona.linkedInProfile.pictureUrl &&
                !loadedPicture && <div className="fake-img test" />}
            </div>
            <div
              className="linkedin__link"
              onClick={openLinkedinProfilePersona}
            >
              <img src={linkIconAccent} alt="linkIcon" />
              <span className="text-accent">{personFullName}</span>
            </div>
          </div>
        ) : (
          <div className="linkedin__account">
            <div className="linkedin__image">
              {linkedInfo.pictureUrl && (
                <img
                  src={linkedInfo.pictureUrl}
                  alt="avatar"
                  className={!loadedPicture ? "hidden-block" : ""}
                  onLoad={() => setLoadedPicture(true)}
                />
              )}
              {!linkedInfo.pictureUrl && <div className="fake-img qwe" />}
              {linkedInfo.pictureUrl && !loadedPicture && (
                <div className="fake-img test" />
              )}
            </div>
            <div className="linkedin__link" onClick={openLinkedinProfile}>
              <img src={linkIcon} alt="linkIcon" />
              <span>
                {linkedInfo.givenName} {linkedInfo.familyName}
              </span>
            </div>
          </div>
        )}
        <div className="line__account"></div>
      </div>
    </div>
  );
};

export default LinkedInBlock;
